import { Component } from '@angular/core';

@Component({
  selector: 'app-parents',
  templateUrl: './parents.component.html',
  styleUrls: ['./parents.component.scss'],
  standalone: false,
})
export class ParentsComponent {
  benifits = [
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-image-1.png',
      heading: 'Real-Time Progress Tracking',
      description: 'Automate daily tasks to save time and reduce paperwork.',
      number: '01',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-image-2.png',
      heading: 'Easy Communication with Teachers',
      description:
        'Stay in touch with educators through seamless messaging and updates.',
      number: '02',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-image-3.png',
      heading: 'Seamless Transitions Between Inforida Schools',
      description:
        'Easily move your child between Inforida schools without disrupting their curriculum.',
      number: '03',
    },
    {
      imageUrl:
        'https://inforida.ams3.cdn.digitaloceanspaces.com/assets/parents-image-4.png',
      heading: 'Secure Access to School Resources',
      description:
        'Access homework, grades, and school materials securely from any device.',
      number: '04',
    },
  ];
}
